import { Button, Tag } from 'antd'
import {
  ClockCircleOutlined,
  DownloadOutlined,
  FileOutlined,
} from '@ant-design/icons'
import BAPLIE_FILE_TYPES from 'constants/baplieFileTypes'
import BAPLIE_SYNC_STATUSES from 'constants/baplieSyncStatuses'
import { formatBackendDateTimeNaive } from 'global/util/time'
import Icon from '@ant-design/icons'
import PropTypes from 'prop-types'
import React from 'react'
import Text from 'components/Text'

import { ReactComponent as DischargeContainer } from 'assets/icons/discharge-container.svg'
import { ReactComponent as LoadContainer } from 'assets/icons/load-container.svg'
import { ReactComponent as RestowContainer } from 'assets/icons/restows.svg'

const HistoryList = ({
  downloadLabel,
  fileTypeLabels,
  items,
  onDownload,
  renderDeviceStatus,
}) => (
  <div className="baplie-or-restow-history__list">
    {items.map(item => {
      const itemTypeClass =
        item.type === BAPLIE_FILE_TYPES.DISCHARGE
          ? 'baplie-or-restow-history__item--discharge'
          : item.type === BAPLIE_FILE_TYPES.LOAD
          ? 'baplie-or-restow-history__item--load'
          : item.type === BAPLIE_FILE_TYPES.RESTOW
          ? 'baplie-or-restow-history__item--restow'
          : ''

      return (
        <div
          className={`baplie-or-restow-history__item ${itemTypeClass}`}
          key={item.id}
        >
          <div className="baplie-or-restow-history__item-header">
            <div className="baplie-or-restow-history__file-type">
              {item.type === BAPLIE_FILE_TYPES.DISCHARGE && (
                <Tag
                  className="baplie-or-restow-history__file-type-tag baplie-or-restow-history__file-type-tag--discharge"
                  icon={<Icon component={DischargeContainer} />}
                >
                  {fileTypeLabels?.[BAPLIE_FILE_TYPES.DISCHARGE] || 'DISCHARGE'}
                </Tag>
              )}
              {item.type === BAPLIE_FILE_TYPES.LOAD && (
                <Tag
                  className="baplie-or-restow-history__file-type-tag baplie-or-restow-history__file-type-tag--load"
                  icon={<Icon component={LoadContainer} />}
                >
                  {fileTypeLabels?.[BAPLIE_FILE_TYPES.LOAD] || 'LOAD'}
                </Tag>
              )}
              {item.type === BAPLIE_FILE_TYPES.RESTOW && (
                <Tag
                  className="baplie-or-restow-history__file-type-tag baplie-or-restow-history__file-type-tag--restow"
                  icon={<Icon component={RestowContainer} />}
                >
                  {fileTypeLabels?.[BAPLIE_FILE_TYPES.RESTOW] || 'RESTOW'}
                </Tag>
              )}

              <div className="baplie-or-restow-history__upload-time">
                <ClockCircleOutlined className="baplie-or-restow-history__upload-time-icon" />
                <Text>{formatBackendDateTimeNaive(item.uploadedTime)}</Text>
              </div>
            </div>

            <div className="baplie-or-restow-history__item-header-actions">
              <Button
                className="baplie-or-restow-history__download-button"
                icon={<DownloadOutlined />}
                onClick={() => onDownload(item.id, item.filename, item.type)}
                size="small"
                type="default"
              >
                {downloadLabel}
              </Button>
            </div>
          </div>

          <div className="baplie-or-restow-history__file-section">
            <div className="baplie-or-restow-history__filename-wrapper">
              <FileOutlined className="baplie-or-restow-history__filename-icon" />
              <Text className="baplie-or-restow-history__filename">
                {item.filename}
              </Text>
            </div>
          </div>

          {renderDeviceStatus(item.devices)}
        </div>
      )
    })}
  </div>
)

HistoryList.propTypes = {
  downloadLabel: PropTypes.string.isRequired,
  fileTypeLabels: PropTypes.objectOf(PropTypes.string),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      devices: PropTypes.arrayOf(
        PropTypes.shape({
          deviceName: PropTypes.string.isRequired,
          deviceid: PropTypes.string.isRequired,
          syncAt: PropTypes.string,
          syncStatus: PropTypes.oneOf(Object.values(BAPLIE_SYNC_STATUSES))
            .isRequired,
        })
      ).isRequired,
      filename: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf(Object.values(BAPLIE_FILE_TYPES)).isRequired,
      uploadedTime: PropTypes.string.isRequired,
    })
  ).isRequired,
  onDownload: PropTypes.func.isRequired,
  renderDeviceStatus: PropTypes.func.isRequired,
}

export default HistoryList
